import { render, staticRenderFns } from "./CompanyMainJourney.vue?vue&type=template&id=c4260b3a"
import script from "./CompanyMainJourney.vue?vue&type=script&lang=js"
export * from "./CompanyMainJourney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports